import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Configuration } from '../../../analytics-core/interfaces/configuration.interface';
import { AnalyticsDataModel } from '../../../analytics/models/analytics.datamodel';

@Component({
	selector: 'app-navigate-to-default-route',
	styleUrls: ['./navigate-to-default-route.component.css'],
	templateUrl: './navigate-to-default-route.component.html'
})
export class NavigateToDefaultRouteComponent implements OnInit {
	public config: Configuration = {} as Configuration;
	public isR10 = false;
	public isR13 = false;

	constructor(private router: Router, private analyticsDataModel: AnalyticsDataModel) {}

	ngOnInit(): void {
		this.config = this.analyticsDataModel.config;
		this.isR10 = this.analyticsDataModel.config.version.toLowerCase() === 'r10' ? true : false;
		this.isR13 = this.analyticsDataModel.config.version.toLowerCase() === 'r13' ? true : false;
	}

	navigateToDefaultRoute(event: any): void {
		this.router.navigate(['/dashboard/' + this.config.routing.defaultRoute], {
			queryParams: this.analyticsDataModel.getQueryParamsObj()
		});
	}
}
